<template>
    <div class=" el-row">
        
    </div>
</template>




<script>
    export default
    {   name: 'Footer',
        data()
        {   return {
                Visita: '',
            }
        },
        methods: {
            GetVisitas()
            {   if(this.$cookies.get("PDVisitas"))
                {   this.Visita = this.$cookies.get("PDVisitas");
                }
            }
        },
        beforeMount()
        {   this.GetVisitas();
        }
    };
</script>



<style>
    .pie
    {   background: rgba(255,255,255,0.5);
        padding: 20px;
        color: #26A5D2;
        font-weight: bold;
        text-shadow: -1px -1px 1px #fff, 1px 1px 1px #fff, -1px 1px 1px #fff, 1px -1px 1px #fff;
        font-size: 16px;
    }
</style>
